export class UISettings {
  DocumentListSize: number = 10;
  OwnerListSize: number = 10;
  WorkAssignmentListSize: number = 10;
  ReportListSize: number = 10;
}